// extracted by mini-css-extract-plugin
module.exports = {"modal_content":"NewCartModal_modal_content__IRUBB"};